import OwlCarousel from 'react-owl-carousel';
import { DashboardCricketMatch } from '../../../component';
import MatchTabHome from '../../../component/home_tab';
import MatchCardWrapper from '../../../component/match_card_wrapper';
import constants from '../../../constants';
import DefaultContainer from '../../default_container';
import './index.css';
import { useLink } from 'react-router-stack';
import GamesPosterCard from '../../../component/games_poster_card';
import React from 'react';
import GuideTour from '../../../component/guide_tour';
import Footer from '../../../component/footer';
import SpinTheWheel from '../../../component/spinTheWheel';

const HomePageWeb = ({
  onViewAllMatchCard,
  suggestionsHandler,
  mainCarousalConfig,
  bannerImages,
  onClickSpinTheWheel,
  teamName,
  miniGamesList = []
}: any) => {
  const navigate = useLink();
  const isGuideTourCompleted =
    localStorage.getItem(constants.GuideTour['home_page'].key) === 'true';
  return (
    <DefaultContainer isWelcomeMessage={true}>
      <div className="homePage__wrapper__web" id="home_page">
        <div className={'homePageCarousalAreaContainer'}>
          {!isGuideTourCompleted && teamName && (
            <GuideTour
              steps={constants.GuideTour['home_page'].steps}
              keyValue={constants.GuideTour['home_page'].key}
              elementId={'home_page'}
            />
          )}
          <div className="fullWidth">
            <OwlCarousel className="owl-theme" {...mainCarousalConfig}>
              {bannerImages.length > 0 &&
                bannerImages.map((game: any) => (
                  <img className="fullWidth" src={game.image} key={game.key} />
                ))}
            </OwlCarousel>
          </div>
        </div>
        <div className="dailyRewards__spintTheWheel__img_wrapper__web">
          <img
            className="spinTheWheel__img__web"
            src={constants.Images.spinTheWheel}
            onClick={onClickSpinTheWheel}
          />
          <img
            className="dailyRewards__img__web"
            src={constants.Images.dailyRewards}
            onClick={() => navigate.push('daily_rewards')}
          />
        </div>
        <MatchTabHome />
        <MatchCardWrapper
          iconSrc={constants.Images.fantasyCricketIcon}
          title={'Upcoming Cricket Matches'}
          onClickHandler={() => onViewAllMatchCard('cricketMatches')}>
          <DashboardCricketMatch />
        </MatchCardWrapper>
        <div style={{ marginTop: '40px' }}>
          <MatchCardWrapper
            iconSrc={constants.Images.leaderboard}
            title={'Leaderboard Games'}
            onClickHandler={() => {
              navigate.push('/leaderboard_games');
            }}>
            <div className="homepage_games_match_card_wrapper">
              {miniGamesList
                .filter((item: any) => item.gameType !== 'playerVsPlayer')
                .map((item: any, idx: any) => (
                  <React.Fragment key={idx}>
                    <GamesPosterCard
                      item={item}
                      idx={idx}
                      onGamePosterClick={suggestionsHandler}
                      isFooter={false}
                    />
                  </React.Fragment>
                ))}
            </div>
          </MatchCardWrapper>
        </div>
        <div style={{ marginTop: '50px' }}>
          <MatchCardWrapper
            iconSrc={constants.Images.playerVsPlayerGames}
            title={'Player VS Player Games'}
            onClickHandler={() => {
              navigate.push('/pvp_games');
            }}>
            <div className="homepage_games_match_card_wrapper">
              {miniGamesList
                .filter((item: any) => item.gameType === 'playerVsPlayer')
                .map((item: any, idx: any) => (
                  <React.Fragment key={idx}>
                    <GamesPosterCard
                      item={item}
                      idx={idx}
                      onGamePosterClick={suggestionsHandler}
                      isFooter={false}
                    />
                  </React.Fragment>
                ))}
            </div>
          </MatchCardWrapper>
        </div>
        <Footer />
        <SpinTheWheel />
      </div>
    </DefaultContainer>
  );
};

export default HomePageWeb;
